export default function Spinner({
  label,
  size = 72,
  overlay = false,
  fullPage = false,
}) {
  const ring = (
    <svg
      width={size} height={size} viewBox="0 0 100 100" aria-hidden="true"
      style={{ filter: 'drop-shadow(0 0 6px rgba(243, 61, 61, 0.8))' }}
    >
      <circle
        cx="50" cy="50" r="38"
        fill="none"
        stroke="silver"
        strokeWidth="9"
        strokeLinecap="butt"
        strokeDasharray="50 29.587"
      >
        <animateTransform
          attributeName="transform" type="rotate"
          from="0 50 50" to="360 50 50"
          dur="1.1s" repeatCount="indefinite"
        />
      </circle>
    </svg>
  );

  const content = (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '1rem',
    }}>
      {ring}
      {label && (
       
            <h1>
                {label}
            </h1>
         
       
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div style={{
        position: 'fixed', inset: 0,
        zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
      }}>
        {content}
      </div>
    );
  }

  if (overlay) {
    return (
      <div style={{
        position: 'absolute', inset: 0,
        zIndex: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
      }}>
        {content}
      </div>
    );
  }

  return content;
}